import { useEffect, useRef } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function playReminderSound() {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    // Three ascending tones for reminder
    [440, 554, 659].forEach((freq, i) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.frequency.value = freq;
      osc.type = 'sine';
      const start = ctx.currentTime + i * 0.2;
      gain.gain.setValueAtTime(0.25, start);
      gain.gain.exponentialRampToValueAtTime(0.001, start + 0.4);
      osc.start(start);
      osc.stop(start + 0.4);
    });
  } catch {}
}

export default function ReminderAlert() {
  const alerted = useRef(new Set());

  useEffect(() => {
    const check = async () => {
      try {
        const res = await axios.get(`${API}/reminders/due`, { withCredentials: true });
        const due = res.data || [];
        let hasNew = false;
        for (const r of due) {
          if (!alerted.current.has(r.reminder_id)) {
            alerted.current.add(r.reminder_id);
            hasNew = true;
          }
        }
        if (hasNew && due.length > 0) {
          playReminderSound();
          // Show browser notification if permission granted
          if (Notification.permission === 'granted') {
            const latest = due[0];
            new Notification(latest.title, { body: latest.description || `${latest.reminder_type} - ${latest.reminder_date} ${latest.reminder_time}`, icon: '/favicon.ico' });
          } else if (Notification.permission !== 'denied') {
            Notification.requestPermission();
          }
        }
      } catch {}
    };
    check();
    const interval = setInterval(check, 30000); // check every 30s
    return () => clearInterval(interval);
  }, []);

  // Request notification permission on mount
  useEffect(() => {
    if ('Notification' in window && Notification.permission === 'default') {
      Notification.requestPermission();
    }
  }, []);

  return null; // invisible component
}
